import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Grid, CardMedia, CardContent } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import axios from 'axios';

import ChurchList from './ChurchList';
import SERVER_API_URL from '../../../config';
import { fNumber } from '../../../utils/formatNumber';

const APP_BAR_MOBILE = 72;
const APP_BAR_DESKTOP = 92;
const StyledBox = styled(Box)(({ theme }) => ({
  paddingTop: APP_BAR_MOBILE,
  [theme.breakpoints.up('sm')]: {
    paddingTop: APP_BAR_DESKTOP,
  },
}));

export default function SingleDistrictChurchList({ selectedDistrict }) {
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    const getAvatarById = async () => {
      try {
        const response = await axios.get(`${SERVER_API_URL}/getDistrictAvatar/getAvatarById/${selectedDistrict && selectedDistrict.id}`, {
          responseType: 'blob',
        });
        if (response.status === 200) {
          setAvatar(URL.createObjectURL(response.data));
        }else{
          throw new Error('Failed to fetch avatar');
        }
      } catch (e) {
        console.log('Error fetching avatar:', e);
        // throw e;
      }
    }
    getAvatarById();

  }, [selectedDistrict]);

  return (
    <>
      <Container maxWidth="xl">
        <StyledBox>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={4}>
              {avatar && (
                <CardMedia
                  component="div"
                  sx={{
                    // 16:9
                    pt: '56.25%',
                  }}
                  image={avatar}
                />
              )}
              {!avatar && (
                <CardMedia
                  component="div"
                  sx={{
                    // 16:9
                    pt: '56.25%',
                  }}
                  image="/assets/landing/empty_district.png"
                />
              )}
              <CardContent sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography gutterBottom variant="h5" component="h2">
                  {selectedDistrict && selectedDistrict.name} ወረዳ
                </Typography>
                <Typography gutterBottom variant="body2" color="darkgray">
                  የአጥቢያ ብዛት ፡ {fNumber(selectedDistrict.Church.length)}
                </Typography>
              </CardContent>
            </Grid>
            <Grid item xs={12} lg={8}>
              <Typography variant="h5" color="text.secondary" paragraph>
                {selectedDistrict && selectedDistrict.description}
              </Typography>{' '}
              <Typography variant="h5" color="text.secondary" paragraph>
                {selectedDistrict && selectedDistrict.history}
              </Typography>
            </Grid>
          </Grid>
        </StyledBox>
      </Container>
      <Container sx={{ pb: 2 }} maxWidth="lg">
        <ChurchList churchList={selectedDistrict && selectedDistrict.Church} />
      </Container>
    </>
  );
}

SingleDistrictChurchList.propTypes = {
  selectedDistrict: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    history: PropTypes.string.isRequired,
    Church: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      })
    ).isRequired,
  }),
};
